/* Product carousel (sections/cs-product-carousel.liquid)
   Switches between collection tabs and slides the active row of cards with
   the shared Embla carousel manager. Arrows are disabled at either end. */

if (!customElements.get('cs-product-carousel')) {
  customElements.define(
    'cs-product-carousel',
    class CsProductCarousel extends HTMLElement {
      connectedCallback() {
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.tabs = [...this.querySelectorAll('[data-tab]')];
        this.prevButtons = [...this.querySelectorAll('[data-prev]')];
        this.nextButtons = [...this.querySelectorAll('[data-next]')];
        this.activeIndex = 0;

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.select(Number(tab.dataset.tab)));
        });
        this.prevButtons.forEach((button) => button.addEventListener('click', () => this.embla()?.scrollPrev()));
        this.nextButtons.forEach((button) => button.addEventListener('click', () => this.embla()?.scrollNext()));

        this.whenManagerReady().then(() => this.initPanel(0));
      }

      whenManagerReady() {
        return new Promise((resolve) => {
          const check = () => {
            if (window.emblaCarouselManager) {
              window.emblaCarouselManager.loadEmblaScript().then(resolve);
            } else {
              setTimeout(check, 50);
            }
          };
          check();
        });
      }

      carouselId(index) {
        return `product-carousel-${this.dataset.sectionId}-${index}`;
      }

      embla() {
        return window.emblaCarouselManager?.instances[this.carouselId(this.activeIndex)];
      }

      initPanel(index) {
        const panel = this.panels[index];
        if (!panel) return;
        const viewport = panel.querySelector('.embla__viewport');
        const embla = window.emblaCarouselManager.initCarousel(this.carouselId(index), viewport, {
          align: 'start',
          containScroll: 'trimSnaps',
          slidesToScroll: 1,
        });
        if (!embla) return;
        ['init', 'reInit', 'select', 'scroll'].forEach((event) => embla.on(event, () => this.updateArrows()));
        this.updateArrows();
      }

      select(index) {
        if (index === this.activeIndex) return;
        this.activeIndex = index;

        this.tabs.forEach((tab, i) => tab.setAttribute('aria-selected', String(i === index)));
        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
        });

        if (this.embla()) {
          this.embla().reInit();
          this.embla().scrollTo(0, true);
        } else {
          this.initPanel(index);
        }
        this.updateArrows();
      }

      updateArrows() {
        const embla = this.embla();
        const canPrev = embla ? embla.canScrollPrev() : false;
        const canNext = embla ? embla.canScrollNext() : false;
        this.prevButtons.forEach((button) => (button.disabled = !canPrev));
        this.nextButtons.forEach((button) => (button.disabled = !canNext));
      }
    }
  );
}
